import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  React
};